export default class BaseModule {
  constructor(resizer) {
    this.overlay = resizer.overlay
    this.img = resizer.img
    this.options = resizer.options
    this.requestUpdate = resizer.onUpdate.bind(resizer)
  }
  onCreate () {}
  onDestroy () {}
  onUpdate () {}
}



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/image-resize/modules/baseModule.js